import { logout } from "@/api/auth/requests";
import { setJWT, setRefreshToken } from "@/helpers/auth";
import { paths } from "@/router/paths";
import { useQueryClient } from "@tanstack/react-query";
import useAPIErrors from "@/hooks/useAPIErrors";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";

const useLogout = () => {
  const client = useQueryClient();
  const { handleErrors } = useAPIErrors();
  const navigate = useNavigate();
  const { setWorkspace } = useAuth();

  return async () => {
    const { response } = await handleErrors(
      () => logout(),
      "Something went wrong"
    );
    if (response) {
      client.clear();
      await setJWT("");
      await setRefreshToken("");
      await setWorkspace("");
      navigate(paths.auth.login);
    }
  };
};

export default useLogout;
